module.exports = __webpack_public_path__ + "img/404.033aafc9.svg";